import { React, useEffect, useState } from "react";
import CustomInput from "../components/CustomInput";
import ReactQuill from "react-quill";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "react-quill/dist/quill.snow.css";
import { toast } from "react-toastify";
import * as yup from "yup";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { getMetal } from "../features/metal/metalSlice";
import { getPurity } from "../features/purity/puritySlice";
import { getPromotionals } from "../features/promotype/promotypeSlice";
import { getCategories } from "../features/pcategory/pcategorySlice";
// import { getColors } from "../features/color/colorSlice";
import { deleteProductImage } from "../features/product/productSlice";
import { Select } from "antd";
import Dropzone from "react-dropzone";
import ImageCropperModal from "../components/ImageCropperModal";
import {
  createProducts,
  getAProduct,
  updateAProduct,
  resetState
} from "../features/product/productSlice";
import { resolveMediaUrl } from "../utils/mediaUrl";

// Helper: treat empty string as undefined so optional number fields don't show typeError
const optionalNumber = () =>
  yup
    .number()
    .transform((value, originalValue) =>
      String(originalValue).trim() === "" ? undefined : value
    )
    .typeError("Must be a valid number")
    .nullable()
    .optional();

let schema = yup.object().shape({
  // --- Required fields (matching backend validation) ---
  product_name: yup.string().required("Product title is required"),
  about_this_item: yup.string().required("Description is required"),
  category: yup.string().required("Category is required"),
  metal_type: yup.string().required("Metal type is required"),
  gender: yup.string().required("Gender is required"),
  weight: yup
    .number()
    .transform((value, originalValue) =>
      String(originalValue).trim() === "" ? undefined : value
    )
    .typeError("Weight must be a number")
    .positive("Weight must be greater than 0")
    .required("Weight is required"),
  product_images: yup.array()
    .test("min-three-images", "At least 3 images are required", (value) => {
      if (!value || !Array.isArray(value)) return false;
      const nonArr = value.filter(img => img !== undefined && img !== null && img !== "");
      return nonArr.length >= 3;
    }),

  // --- Optional numeric fields ---
  height: optionalNumber(),
  width: optionalNumber(),
  discount: optionalNumber(),
  making_charges_per_gm: optionalNumber(),
  hall_mark_charges: optionalNumber(),
  additional_charges: optionalNumber(),
  gross_weight: optionalNumber(),
  net_weight: optionalNumber(),
  pcs: optionalNumber(),
  size: yup.string().optional(),

  // --- Conditional: price required only when price_is_fixed = true ---
  price: yup.number().when("price_is_fixed", {
    is: true,
    then: (schema) =>
      schema
        .transform((value, originalValue) =>
          String(originalValue).trim() === "" ? undefined : value
        )
        .typeError("Price must be a number")
        .min(0, "Price cannot be negative")
        .required("Price is required for fixed price products"),
    otherwise: (schema) => schema.optional().nullable(),
  }),

  // --- Optional string fields (no validation needed) ---
  purity: yup.string().optional(),
  promo_type: yup.string().optional(),
  design_code: yup.string().optional(),
  discount_type: yup.string().optional(),
  making_type: yup.string().optional(),
});

const Addproduct = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  // const { id } = useParams();
  const id = location.pathname.split("/")[3];
  // const [color, setColor] = useState([]);
  const [selectedMetal, setSelectedMetal] = useState("");
  const [discountType, setDiscountType] = useState("");
  const [makingType, setMakingType] = useState("flat");
  const [priceType, setPriceType] = useState(true);
  const [pendingFile, setPendingFile] = useState(null);
  const [cropOpen, setCropOpen] = useState(false);
  const [activeSlotIndex, setActiveSlotIndex] = useState(null);
  const productDetails = useSelector((state) => state.product);
  const { isSuccess, isError, isLoading, createdProduct, updatedProduct } = useSelector((state) => state.product);

  const catState = useSelector((state) => state.pCategory.pCategories);
  // const colorState = useSelector((state) => state.color.colors);
  const metalState = useSelector((state) => state.metal.Metal);
  const purityState = useSelector((state) => state.purity.Purity);
  const promoStat = useSelector((state) => state.promoType.promoLists);

  const [filteredPurity, setFilteredPurity] = useState([]);

  useEffect(() => {
    dispatch(getMetal());
    dispatch(getPurity());
    dispatch(getPromotionals());
    dispatch(getCategories());
    // dispatch(getColors());
  }, [dispatch]);

  useEffect(() => {
    return () => {
      // This will run when component unmounts
      dispatch(resetState());
    };
  }, [dispatch]);

  // useEffect(() => {
  //   if (isSuccess && createdProduct) {
  //     toast.success("Product Added Successfully!");
  //     navigate("/admin/list-product");
  //     dispatch(resetState());
  //   }
  //   if (isError) {
  //     toast.error("Something Went Wrong!");
  //   }
  // }, [isSuccess, isError, isLoading, createdProduct, navigate, dispatch]);



  useEffect(() => {
    if (isSuccess && updatedProduct) {
      toast.success("Product Updated Successfully!");
      navigate("/admin/list-product");
    }
  }, [isSuccess, updatedProduct, navigate]);

  useEffect(() => {
    if (selectedMetal) {
      const filtered = purityState.filter(purity => purity.metal_type?._id === selectedMetal);
      setFilteredPurity(filtered);
    } else {
      setFilteredPurity(purityState);
    }
  }, [selectedMetal, purityState]);



  const formik = useFormik({
    enableReinitialize: !!id,
    initialValues: {
      product_name: productDetails.productName || "",
      about_this_item: productDetails.aboutProduct || "",
      category: productDetails.categoryId || "",
      metal_type: productDetails.metalId || "",
      purity: productDetails.PurityId || "",
      promo_type: productDetails.promoId || "",
      gender: productDetails.gender || "",
      // color: productDetails.color || [],
      discount: productDetails.discount || "",
      discount_type: discountType || "none",
      weight: productDetails.weight || "",
      height: productDetails.height || "",
      width: productDetails.width || "",
      gross_weight: productDetails.gross_weight || "",
      net_weight: productDetails.net_weight || "",
      pcs: productDetails.pcs || "",
      size: productDetails.size || "",

      making_type: productDetails.makingType || "flat",
      making_charges_per_gm: productDetails.makingCharge || "",
      // making_charges_per_gm: productDetails.makingChargePercentage || "",
      hall_mark_charges: productDetails.hallMark || "",
      additional_charges: productDetails.additionalCharges || "",
      price_is_fixed: productDetails.priceType !== undefined ?
        (typeof productDetails.priceType === 'boolean' ?
          productDetails.priceType :
          productDetails.priceType === 'true') :
        true,
      // price_is_fixed: productDetails.priceType !== undefined ? productDetails.priceType : true,
      price: productDetails.price || 0,

      // making_charges_per_gm: productDetails.makingCharge || "",
      // price: productDetails.price || 0,
      design_code: productDetails.designCode || "",
      product_images: (() => {
        const arr = Array(5).fill("");
        if (productDetails.productImages && Array.isArray(productDetails.productImages)) {
          productDetails.productImages.forEach((img, idx) => {
            if (idx < 5) arr[idx] = img;
          });
        }
        return arr;
      })(),
      show_price: productDetails.show_price !== undefined ? productDetails.show_price : true,
    },
    validationSchema: schema,

    onSubmit: async (values) => {
      console.log('Form values:', values);
      const formData = new FormData();
      formData.append("product_name", values.product_name);
      formData.append("about_this_item", values.about_this_item);
      formData.append("category", values.category);
      formData.append("metal_type", values.metal_type);
      formData.append("purity", values.purity);
      formData.append("promo_type", values.promo_type);
      formData.append("gender", values.gender);
      formData.append("discount", values.discount);
      if (values.price_is_fixed) {
        formData.append("price", values.price || 0);
      } else {
        formData.append("price", "0");
      }
      // formData.append("price", values.price || 0);
      formData.append("discount_type", values.discount_type);
      formData.append("weight", values.weight);
      formData.append("height", values.height);
      formData.append("width", values.width);
      formData.append("gross_weight", values.gross_weight);
      formData.append("net_weight", values.net_weight);
      formData.append("pcs", values.pcs);
      formData.append("size", values.size);
      formData.append("making_type", values.making_type);
      formData.append("price_is_fixed", values.price_is_fixed.toString());
      formData.append("hall_mark_charges", values.hall_mark_charges);
      formData.append("additional_charges", values.additional_charges);
      // formData.append("making_charges_per_gm", values.making_charges_per_gm);
      formData.append("making_charges_per_gm", values.making_charges_per_gm);
      formData.append("design_code", values.design_code);
      formData.append("show_price", values.show_price.toString());

      // values.color.forEach((color) => {
      //   formData.append("color", color);
      // });

      // Build image FormData entries directly from formik values
      // (File/Blob objects are the actual compressed files; strings are retained server URLs)
      const allProductImages = formik.values.product_images || [];
      for (const img of allProductImages) {
        if (img instanceof File) {
          // Newly uploaded file — send with its original filename
          formData.append("product_images", img, img.name || "product-image.jpg");
        } else if (img instanceof Blob) {
          formData.append("product_images", img, "product-image.jpg");
        } else if (typeof img === "string" && img.trim() !== "" && !img.startsWith("blob:")) {
          // Existing server path — retained during edit
          formData.append("product_images", img);
        }
      }

      console.log("Submitting form with values:", values);
      // API call — Formik only reaches onSubmit if Yup validation passed
      if (id) {
        // --- UPDATE PRODUCT ---
        const data = { id, products: formData };
        const result = await dispatch(updateAProduct(data));
        if (updateAProduct.rejected.match(result)) {
          const errorMsg =
            result.payload ||
            result.error?.message ||
            "Failed to update product. Please try again.";
          toast.error(errorMsg);
          return; // Stay on the form, don't reset or navigate
        }
        // success is handled by useEffect above
      } else {
        // --- CREATE PRODUCT ---
        const result = await dispatch(createProducts(formData));
        if (createProducts.rejected.match(result)) {
          const errorMsg =
            result.payload ||
            result.error?.message ||
            "Failed to add product. Please try again.";
          toast.error(errorMsg);
          return; // Stay on the form, don't reset or navigate
        }
        toast.success("Product Added Successfully!");
        formik.resetForm({
          values: {
            product_name: "",
            about_this_item: "",
            category: "",
            metal_type: "",
            purity: "",
            promo_type: "",
            gender: "",
            discount: "",
            discount_type: "none",
            weight: "",
            height: "",
            width: "",
            gross_weight: "",
            net_weight: "",
            pcs: "",
            size: "",
            making_type: "flat",
            making_charges_per_gm: "",
            hall_mark_charges: "",
            additional_charges: "",
            price_is_fixed: true,
            price: 0,
            design_code: "",
            product_images: Array(5).fill(""),
            show_price: true,
          }
        });
        setSelectedMetal("");
        setDiscountType("none");
        setMakingType("flat");
        setPriceType(true);
        navigate("/admin/list-product");
      }
    },
  });

  // const coloropt = [];
  // colorState.forEach((i) => {
  //   coloropt.push({
  //     label: i.color_name,
  //     // value: i.color_name,
  //     value: i._id,
  //   });
  // });

  // const handleColors = (selectedColors) => {
  //   setColor(selectedColors);
  //   // console.log("selected color",typeof selectedColors);
  //   console.log("handle color",selectedColors);
  //   formik.setFieldValue("color", selectedColors);
  // };

  const handleMetalChange = (e) => {
    // formik.handleChange(e);
    formik.setFieldValue("metal_type", e.target.value);
    setSelectedMetal(e.target.value);
  };

  const handleSlotImageSelect = (acceptedFiles, slotIndex) => {
    if (acceptedFiles.length > 0) {
      setPendingFile(acceptedFiles[0]);
      setActiveSlotIndex(slotIndex);
      setCropOpen(true);
    }
  };

  const handleSlotImageDelete = (slotIndex) => {
    const val = formik.values.product_images[slotIndex];
    if (typeof val === "string" && val !== "") {
      dispatch(deleteProductImage(val));
    }
    const updatedImages = [...formik.values.product_images];
    updatedImages[slotIndex] = "";
    formik.setFieldValue("product_images", updatedImages);
  };

  useEffect(() => {
    if (productDetails) {
      setDiscountType(productDetails.discountType || "none");
      // setColor(productDetails.colorName || []);
      //  formik.setFieldValue("color", productDetails.colorName || []);
      //  handleColors(productDetails.colorId || [])
    }
  }, [productDetails]);


  useEffect(() => {
    if (id !== undefined) {
      dispatch(getAProduct(id));
    } else {
      dispatch(resetState());
      formik.resetForm({
        values: {
          product_name: "",
          about_this_item: "",
          category: "",
          metal_type: "",
          purity: "",
          promo_type: "",
          gender: "",
          discount: "",
          discount_type: "none",
          weight: "",
          height: "",
          width: "",
          gross_weight: "",
          net_weight: "",
          pcs: "",
          size: "",
          making_type: "flat",
          making_charges_per_gm: "",
          hall_mark_charges: "",
          additional_charges: "",
          price_is_fixed: true,
          price: 0,
          design_code: "",
          product_images: Array(5).fill(""),
          show_price: true,
        }
      });
      setSelectedMetal("");
      setDiscountType("none");
      setMakingType("flat");
      setPriceType(true);
    }
    return () => {
      dispatch(resetState());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, dispatch]);


  useEffect(() => {
    if (isError) {
      toast.error("Something Went Wrong!");
      console.log("Error:", productDetails.message);
    }
  }, [isError, productDetails.message]);

  return (
    <div>
      <h3 className="mb-4 title">{id !== undefined ? "Edit Product" : "Add Product"}</h3>
      <div>
        <form
          onSubmit={formik.handleSubmit}
          className="d-flex gap-2 flex-column"
        >
          <div>
            <label htmlFor="product_name" className="sub-title">
              Product Title
            </label>
            <CustomInput
              type="text"
              label="Enter Product Title"
              name="product_name"
              onChng={formik.handleChange("product_name")}
              onBlr={formik.handleBlur("product_name")}
              val={formik.values.product_name}
            />
            <div className="error">
              {formik.touched.product_name && formik.errors.product_name}
            </div>
          </div>

          <div className="">
            <label htmlFor="product_description" className="sub-title mb-2">
              Description
            </label>
            <ReactQuill
              theme="snow"
              name="about_this_item"
              onChange={(value) => formik.setFieldValue("about_this_item", value)}
              value={formik.values.about_this_item}
            />
            <div className="error">
              {formik.touched.about_this_item && formik.errors.about_this_item}
            </div>
          </div>

          <div>
            <label htmlFor="product_category" className="sub-title">
              Product Category
            </label>
            <select
              name="category"
              onChange={formik.handleChange("category")}
              onBlur={formik.handleBlur("category")}
              value={formik.values.category}
              className="form-control py-1 mb-2 mt-1"
              id=""
            >
              <option value="">Select Category</option>
              {catState.map((i, j) => {
                return (
                  <option key={j} value={i._id}>
                    {i.category_name}
                  </option>
                );
              })}
            </select>
            <div className="error">
              {formik.touched.category && formik.errors.category}
            </div>
          </div>

          <div>
            <label htmlFor="product_metal" className="sub-title">
              Product Metal
            </label>
            <select
              name="metal_type"
              onChange={handleMetalChange}
              onBlur={formik.handleBlur("metal_type")}
              value={formik.values.metal_type}
              className="form-control py-1 mb-2 mt-1"
              id=""
            >
              <option value="">Select Metal</option>
              {metalState.map((i, j) => {
                return (
                  <option key={j} value={i._id}>
                    {i.metal_name}
                  </option>
                );
              })}
            </select>
            <div className="error">
              {formik.touched.metal_type && formik.errors.metal_type}
            </div>
          </div>

          <div>
            <label htmlFor="product_purity" className="sub-title">
              Product Purity
            </label>
            <select
              name="purity"
              onChange={formik.handleChange("purity")}
              onBlur={formik.handleBlur("purity")}
              value={formik.values.purity}
              className="form-control py-1 mb-2 mt-1"
              id=""
            >
              <option value="">Select Purity</option>
              {filteredPurity.map((i, j) => {
                return (
                  <option key={j} value={i._id}>
                    {i.product_purity}
                  </option>
                );
              })}
            </select>
            <div className="error">
              {formik.touched.purity && formik.errors.purity}
            </div>
          </div>

          {/* {(selectedMetal === "gold" || selectedMetal === "Gold") && (
            <div>
              <label htmlFor="product_purity" className="sub-title">
                Product Purity
              </label>
              <select
                name="purity"
                onChange={formik.handleChange("purity")}
                onBlur={formik.handleBlur("purity")}
                value={formik.values.purity}
                className="form-control py-1 mb-2 mt-1"
                id=""
              >
                <option value="">Select Purity</option>
                {purityState.map((i, j) => {
                  return (
                    <option key={j} value={i._id}>
                      {i.product_purity}
                    </option>
                  );
                })}
              </select>
              <div className="error">
                {formik.touched.purity && formik.errors.purity}
              </div>
            </div>
          )} */}

          <div>
            <label htmlFor="promotional_type" className="sub-title">
              Promotional Type
            </label>
            <select
              name="promo_type"
              onChange={formik.handleChange("promo_type")}
              onBlur={formik.handleBlur("promo_type")}
              value={formik.values.promo_type}
              className="form-control py-1 mb-2 mt-1"
              id=""
            >
              <option value="">Select Promotional Type</option>
              {promoStat.map((i, j) => {
                return (
                  <option key={j} value={i._id}>
                    {i.promotype_name}
                  </option>
                );
              })}
            </select>
            <div className="error">
              {formik.touched.promo_type && formik.errors.promo_type}
            </div>
          </div>

          <div>
            <label htmlFor="gender" className="sub-title">
              Gender
            </label>
            <select
              name="gender"
              onChange={formik.handleChange("gender")}
              onBlur={formik.handleBlur("gender")}
              value={formik.values.gender}
              className="form-control py-1 mb-2 mt-1"
              id=""
            >
              <option value="" disabled>
                Select Gender
              </option>
              <option value="male">Male</option>
              <option value="female">Female</option>
              <option value="kids">Kids</option>
              <option value="unisex">Unisex</option>
            </select>
            <div className="error">
              {formik.touched.gender && formik.errors.gender}
            </div>
          </div>

          {/* <div>
            <label htmlFor="product_color" className="sub-title">
              Color
            </label>
            <Select
              mode="multiple"
              allowClear
              className="w-100"
              placeholder="Select colors"
              // defaultValue={color}
              // onChange={(i) => handleColors(i)}
              // options={coloropt}
              value={formik.values.color} // Ensure formik controls the value
              onChange={handleColors}
              options={coloropt}
            />
            <div className="error">
              {formik.touched.color && formik.errors.color}
            </div>
          </div> */}

          <div>
            <label htmlFor="product_weight" className="sub-title">
              Product Weight
            </label>
            <CustomInput
              type="number"
              label="Enter Product Weight"
              name="weight"
              onChng={formik.handleChange("weight")}
              onBlr={formik.handleBlur("weight")}
              val={formik.values.weight}
            />
            <div className="error">
              {formik.touched.weight && formik.errors.weight}
            </div>
          </div>

          <div>
            <label htmlFor="product_height" className="sub-title">
              Product Height
            </label>
            <CustomInput
              type="number"
              label="Enter Product Height"
              name="height"
              onChng={formik.handleChange("height")}
              onBlr={formik.handleBlur("height")}
              val={formik.values.height}
            />
            <div className="error">
              {formik.touched.height && formik.errors.height}
            </div>
          </div>

          <div>
            <label htmlFor="product_width" className="sub-title">
              Product Width
            </label>
            <CustomInput
              type="number"
              label="Enter Product Width"
              name="width"
              onChng={formik.handleChange("width")}
              onBlr={formik.handleBlur("width")}
              val={formik.values.width}
            />
            <div className="error">
              {formik.touched.width && formik.errors.width}
            </div>
          </div>

          <div>
            <label htmlFor="gross_weight" className="sub-title">
              Gross Weight (gms)
            </label>
            <CustomInput
              type="number"
              label="Enter Gross Weight"
              name="gross_weight"
              onChng={formik.handleChange("gross_weight")}
              onBlr={formik.handleBlur("gross_weight")}
              val={formik.values.gross_weight}
            />
            <div className="error">
              {formik.touched.gross_weight && formik.errors.gross_weight}
            </div>
          </div>

          <div>
            <label htmlFor="net_weight" className="sub-title">
              Net Weight (gms)
            </label>
            <CustomInput
              type="number"
              label="Enter Net Weight"
              name="net_weight"
              onChng={formik.handleChange("net_weight")}
              onBlr={formik.handleBlur("net_weight")}
              val={formik.values.net_weight}
            />
            <div className="error">
              {formik.touched.net_weight && formik.errors.net_weight}
            </div>
          </div>

          <div>
            <label htmlFor="pcs" className="sub-title">
              Pcs
            </label>
            <CustomInput
              type="number"
              label="Enter Pcs"
              name="pcs"
              onChng={formik.handleChange("pcs")}
              onBlr={formik.handleBlur("pcs")}
              val={formik.values.pcs}
            />
            <div className="error">
              {formik.touched.pcs && formik.errors.pcs}
            </div>
          </div>



          <div>
            <label htmlFor="size" className="sub-title">
              Size
            </label>
            <CustomInput
              type="text"
              label="Enter Size"
              name="size"
              onChng={formik.handleChange("size")}
              onBlr={formik.handleBlur("size")}
              val={formik.values.size}
            />
            <div className="error">
              {formik.touched.size && formik.errors.size}
            </div>
          </div>

          {/* <div>
            <label htmlFor="making_charge" className="sub-title">
              Making Charges (Per Gram)
            </label>
            <CustomInput
              type="text"
              label="Enter Product Making Charge"
              name="making_charges_per_gm"
              onChng={formik.handleChange("making_charges_per_gm")}
              onBlr={formik.handleBlur("making_charges_per_gm")}
              val={formik.values.making_charges_per_gm}
            />
            <div className="error">
              {formik.touched.making_charges_per_gm && formik.errors.making_charges_per_gm}
            </div>
          </div> */}
          <div>
            <label className="sub-title">Making Charges Type</label>
            <div className="flex items-center space-x-4 mt-1">
              <label>
                <input
                  type="radio"
                  name="makingType"
                  value="flat"
                  checked={formik.values.making_type === "flat"}
                  onChange={() => {
                    formik.setFieldValue("making_type", "flat");
                    formik.setFieldValue("making_charges_per_gm", "");
                  }}
                />{" "}
                Flat
              </label>
              <label className="ms-3">
                <input
                  type="radio"
                  name="makingType"
                  value="percentage"
                  checked={formik.values.making_type === "percentage"}
                  onChange={() => {
                    formik.setFieldValue("making_type", "percentage");
                    formik.setFieldValue("making_charges_per_gm", "");
                  }}
                />{" "}
                Percentage
              </label>
              <label className="ms-3">
                <input
                  type="radio"
                  name="makingType"
                  value="flat_per_gram"
                  checked={formik.values.making_type === "flat_per_gram"}
                  onChange={() => {
                    formik.setFieldValue("making_type", "flat_per_gram");
                    formik.setFieldValue("making_charges_per_gm", "");
                  }}
                />{" "}
                Flat Per Gram
              </label>
            </div>

            {formik.values.making_type === "flat" && (
              <div>
                <label htmlFor="making_charges_per_gm" className="sub-title">
                  Making Charges (Flat)
                </label>
                <CustomInput
                  type="text"
                  label="Enter Flat Making Charges"
                  name="making_charges_per_gm"
                  onChng={formik.handleChange("making_charges_per_gm")}
                  onBlr={formik.handleBlur("making_charges_per_gm")}
                  val={formik.values.making_charges_per_gm}
                />
                <div className="error">
                  {formik.touched.making_charges_per_gm && formik.errors.making_charges_per_gm}
                </div>
              </div>
            )}

            {formik.values.making_type === "flat_per_gram" && (
              <div>
                <label htmlFor="making_charges_per_gm" className="sub-title">
                  Making Charges (Flat Per Gram)
                </label>
                <CustomInput
                  type="text"
                  label="Enter Making Charges (Per Gram)"
                  name="making_charges_per_gm"
                  onChng={formik.handleChange("making_charges_per_gm")}
                  onBlr={formik.handleBlur("making_charges_per_gm")}
                  val={formik.values.making_charges_per_gm}
                />
                <div className="error">
                  {formik.touched.making_charges_per_gm && formik.errors.making_charges_per_gm}
                </div>
              </div>
            )}

            {formik.values.making_type === "percentage" && (
              <div>
                <label htmlFor="making_charges_per_gm" className="sub-title">
                  Making Charges (%)
                </label>
                <CustomInput
                  type="text"
                  label="Enter Making Charges Percentage"
                  name="making_charges_per_gm"
                  onChng={formik.handleChange("making_charges_per_gm")}
                  onBlr={formik.handleBlur("making_charges_per_gm")}
                  val={formik.values.making_charges_per_gm}
                />
                <div className="error">
                  {formik.touched.making_charges_per_gm && formik.errors.making_charges_per_gm}
                </div>
              </div>
            )}
          </div>




          {/* <div>
            <label htmlFor="show_price" className="sub-title">
              Show Price on Website
            </label>
            <div className="flex items-center space-x-4 mt-1">
              <label>
                <input
                  type="radio"
                  name="show_price"
                  value="true"
                  checked={formik.values.show_price === true}
                  onChange={() => formik.setFieldValue("show_price", true)}
                />{" "}
                Yes
              </label>
              <label className="ms-3">
                <input
                  type="radio"
                  name="show_price"
                  value="false"
                  checked={formik.values.show_price === false}
                  onChange={() => formik.setFieldValue("show_price", false)}
                />{" "}
                No
              </label>
            </div>
          </div> */}

          <div>
            <label htmlFor="design_code" className="sub-title">
              Design Code
            </label>
            <CustomInput
              type="text"
              label="Enter Design Code"
              name="design_code"
              onChng={formik.handleChange("design_code")}
              onBlr={formik.handleBlur("design_code")}
              val={formik.values.design_code}
            />
            <div className="error">
              {formik.touched.design_code && formik.errors.design_code}
            </div>
          </div>

          <div>
            <label className="sub-title">Discount (On Making Charges)</label>
            <div className="flex items-center space-x-4 mt-1">
              <label>
                <input
                  type="radio"
                  name="discountType"
                  value="none"
                  checked={discountType === "none"}
                  onChange={() => {
                    setDiscountType("none");
                    // formik.setFieldValue("discount", "");
                    formik.setFieldValue("discount_type", "none");
                  }}
                />{" "}
                None
              </label>
              <label>
                <input
                  type="radio"
                  name="discountType"
                  value="flat"
                  checked={discountType === "flat"}
                  onChange={() => {
                    // setDiscountType("flat");
                    // formik.setFieldValue("discount", "");
                    setDiscountType("flat");
                    formik.setFieldValue("discount_type", "flat");
                    formik.setFieldValue("discount", "");
                  }}
                />{" "}
                Flat
              </label>
              <label>
                <input
                  type="radio"
                  name="discountType"
                  value="percentage"
                  checked={discountType === "percentage"}
                  onChange={() => {
                    // setDiscountType("percentage");
                    // formik.setFieldValue("discount", "");
                    setDiscountType("percentage");
                    formik.setFieldValue("discount_type", "percentage");
                    formik.setFieldValue("discount", "");
                  }}
                />{" "}
                Percentage
              </label>
            </div>

            {discountType === "none" && (
              <input
                type="number"
                name="discount"
                className="form-control py-1 mb-2 mt-1"
                placeholder="0"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.discount}
              />
            )}

            {discountType === "flat" && (
              <input
                type="number"
                name="discount"
                className="form-control py-1 mb-2 mt-1"
                placeholder="Enter Flat Discount"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.discount}
              />
            )}

            {discountType === "percentage" && (
              <input
                type="number"
                name="discount"
                className="form-control py-1 mb-2 mt-1"
                placeholder="Enter Percentage Discount"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.discount}
              />
            )}

            <div className="error">
              {formik.touched.discount && formik.errors.discount}
            </div>
          </div>

          {/* Hall Mark Field */}
          <div>
            <label htmlFor="hall_mark_charges" className="sub-title">
              Hall Mark
            </label>
            <CustomInput
              type="text"
              label="Enter Hall Mark"
              name="hall_mark_charges"
              onChng={formik.handleChange("hall_mark_charges")}
              onBlr={formik.handleBlur("hall_mark_charges")}
              val={formik.values.hall_mark_charges}
            />
            <div className="error">
              {formik.touched.hall_mark_charges && formik.errors.hall_mark_charges}
            </div>
          </div>

          <div>
            <label htmlFor="additional_charges" className="sub-title">
              Additional Charges
            </label>
            <CustomInput
              type="number"
              label="Enter Additional Charges"
              name="additional_charges"
              onChng={formik.handleChange("additional_charges")}
              onBlr={formik.handleBlur("additional_charges")}
              val={formik.values.additional_charges}
              min="0"
            />
            <div className="error">
              {formik.touched.additional_charges && formik.errors.additional_charges}
            </div>
          </div>

          {/* <div>
            <label htmlFor="price" className="sub-title">
              Product Price (Optional)
            </label>
            <CustomInput
              type="number"
              label="Enter Product Price"
              name="price"
              onChng={formik.handleChange("price")}
              onBlr={formik.handleBlur("price")}
              val={formik.values.price}
              min="0"
            />
            <div className="error">
              {formik.touched.price && formik.errors.price}
            </div>
          </div> */}

          {/* Price Type and Value */}
          <div>
            <label className="sub-title">Price Type</label>
            <div className="flex items-center space-x-4 mt-1">
              <label>
                <input
                  type="radio"
                  name="priceType"
                  checked={formik.values.price_is_fixed === true}
                  onChange={() => {
                    formik.setFieldValue("price_is_fixed", true);
                  }}
                />{" "}
                Fixed Price
              </label>
              <label>
                <input
                  type="radio"
                  name="priceType"
                  checked={formik.values.price_is_fixed === false}
                  onChange={() => {
                    formik.setFieldValue("price_is_fixed", false);
                    formik.setFieldValue("price", 0);
                  }}
                />{" "}
                Non-Fixed Price
              </label>
            </div>

            {formik.values.price_is_fixed === true && (
              <div>
                <label htmlFor="price" className="sub-title">
                  Product Price
                </label>
                <CustomInput
                  type="number"
                  label="Enter Product Price"
                  name="price"
                  onChng={formik.handleChange("price")}
                  onBlr={formik.handleBlur("price")}
                  val={formik.values.price}
                  min="0"
                />
                <div className="error">
                  {formik.touched.price && formik.errors.price}
                </div>
              </div>
            )}
          </div>

          <label className="sub-title">Product Images (Upload 5 images, first 3 are required)</label>
          <div className="d-flex flex-wrap gap-3 mt-2">
            {[0, 1, 2, 3, 4].map((idx) => {
              const imgVal = formik.values.product_images[idx];
              const isRequired = idx < 3;
              return (
                <div key={idx} className="d-flex flex-column align-items-center" style={{ width: "150px" }}>
                  <span className="small text-muted mb-1">
                    Image {idx + 1} {isRequired ? <span className="text-danger">*</span> : "(Optional)"}
                  </span>
                  
                  {imgVal ? (
                    <div className="position-relative border rounded overflow-hidden" style={{ width: "150px", height: "150px" }}>
                      <button
                        type="button"
                        onClick={() => handleSlotImageDelete(idx)}
                        className="position-absolute"
                        style={{
                          top: "5px",
                          right: "5px",
                          background: "rgba(0,0,0,0.5)",
                          border: "none",
                          color: "white",
                          borderRadius: "50%",
                          width: "24px",
                          height: "24px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "14px",
                          fontWeight: "bold",
                          zIndex: 10,
                          cursor: "pointer"
                        }}
                      >×</button>
                      <img
                        src={
                          typeof imgVal === "string"
                            ? resolveMediaUrl(imgVal)
                            : URL.createObjectURL(imgVal)
                        }
                        alt={`product slot ${idx + 1}`}
                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                      />
                    </div>
                  ) : (
                    <Dropzone
                      onDrop={(acceptedFiles) => handleSlotImageSelect(acceptedFiles, idx)}
                      multiple={false}
                    >
                      {({ getRootProps, getInputProps }) => (
                        <div
                          {...getRootProps()}
                          className="d-flex flex-column align-items-center justify-content-center border border-dashed rounded bg-white text-center cursor-pointer p-2"
                          style={{ width: "150px", height: "150px", borderStyle: "dashed" }}
                        >
                          <input {...getInputProps()} />
                          <span className="text-muted" style={{ fontSize: "12px" }}>
                            Drag & drop or Click to upload
                          </span>
                        </div>
                      )}
                    </Dropzone>
                  )}
                </div>
              );
            })}
          </div>

          <div className="error">
            {formik.touched.product_images && formik.errors.product_images}
          </div>

          <button
            className="btn btn-success border-0 rounded-3 my-5"
            type="submit"
          >
            {id ? "Update Product" : "Add Product"}
          </button>
        </form>
      </div>

      <ImageCropperModal
        open={cropOpen}
        file={pendingFile}
        title={`Crop Image ${activeSlotIndex !== null ? activeSlotIndex + 1 : ""}`}
        aspect={1}
        outputWidth={800}
        outputHeight={800}
        onCancel={() => {
          setCropOpen(false);
          setPendingFile(null);
          setActiveSlotIndex(null);
        }}
        onCropped={(cropped) => {
          const updatedImages = [...formik.values.product_images];
          updatedImages[activeSlotIndex] = cropped;
          formik.setFieldValue("product_images", updatedImages);
          setCropOpen(false);
          setPendingFile(null);
          setActiveSlotIndex(null);
        }}
      />
    </div>
  );
};

export default Addproduct;